import { Action, Module, VuexModule } from "vuex-module-decorators";
import { ChatHistory } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class ChatHistoryModule extends VuexModule {
    @Action
    [ChatHistory.findPageChatHistory](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/webChatHistory/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [ChatHistory.listChatHistory](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/chatHistory/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [ChatHistory.saveChatHistory](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/chatHistory/save`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [ChatHistory.deleteChatHistory](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/chatHistory/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}